// Ciudad por default según las ciudades asignadas al usuario logueado
// (mismo endpoint /home/ciudades que usa el dashboard).
//
// Regla de negocio:
// - 1 sola ciudad asignada -> esa es la default.
// - Varias ciudades asignadas -> la que empiece con la letra más temprana
//   alfabéticamente, salvo que "San Luis Río Colorado" esté entre ellas, en
//   cuyo caso esa siempre tiene prioridad.
import { useEffect, useState } from "react";
import axios from "axios";
import { PATH } from "../../../../redux/utils";

const api = axios.create({ baseURL: PATH });

const authH = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const normalize = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

export default function useDefaultCiudadUsuario() {
  const [ciudadesUsuario, setCiudadesUsuario] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/home/ciudades", { headers: authH() })
      .then((r) => setCiudadesUsuario(Array.isArray(r.data?.ciudades) ? r.data.ciudades : []))
      .catch(() => setCiudadesUsuario([]))
      .finally(() => setLoaded(true));
  }, []);

  const defaultCiudad = (() => {
    if (!ciudadesUsuario.length) return null;
    if (ciudadesUsuario.length === 1) return ciudadesUsuario[0];

    const sanLuis = ciudadesUsuario.find(
      (c) => normalize(c.nombre) === "san luis rio colorado"
    );
    if (sanLuis) return sanLuis;

    return [...ciudadesUsuario].sort((a, b) =>
      normalize(a.nombre).localeCompare(normalize(b.nombre))
    )[0];
  })();

  return { ciudadesUsuario, loaded, defaultCiudad };
}
